import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { StarRating } from "./StarRating";

const hash = (s) => [...s].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

// Two store-level testimonials, chosen deterministically per product so each page feels distinct but stable
export const ProductTestimonials = ({ productId }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then(({ data }) => {
      if (data.length === 0) return;
      const start = hash(productId) % data.length;
      setItems([data[start], data[(start + 1) % data.length]].filter((t, i, a) => a.findIndex((x) => x.id === t.id) === i));
    }).catch(() => {});
  }, [productId]);

  if (items.length === 0) return null;
  return (
    <div className="mt-8" data-testid="product-testimonials">
      <p className="text-[11px] tracking-[0.25em] uppercase font-semibold text-[#8C7B6B] mb-4">What customers say about ordering with us</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {items.map((t) => (
          <figure key={t.id} className="border border-[#DDD7CF] bg-white p-5 flex flex-col" data-testid={`product-testimonial-${t.id}`}>
            <StarRating value={t.rating} size="w-3.5 h-3.5" />
            <blockquote className="text-sm text-[#1A1A1A] leading-relaxed mt-3 flex-1">“{t.quote}”</blockquote>
            <figcaption className="mt-4 flex items-center gap-x-2 gap-y-1 flex-wrap text-xs text-[#6E675F]">
              <span className="font-semibold text-[#1A1A1A]">{t.name}</span>
              {t.location && <span>· {t.location}</span>}
              <span className="inline-flex items-center gap-1 text-[10px] tracking-[0.1em] uppercase font-semibold text-[#2D6A4F] ml-auto">
                <CheckCircle2 className="w-3 h-3" /> Verified Customer
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
};
